import { ErrorResponseErrorItemCodeBatchDownload } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeBatchDownload, string> = {
  'batch_download:no_items': 'Minst en fil eller mapp måste väljas.',
  'batch_download:items_not_siblings': 'Valda filer och mappar måste ha samma föräldermapp.',
};
